<template>
   <SideBar />
  <div class="p-4 sm:ml-64 min-h-screen bg-gray-900 text-white">
   
    <PresupuestoForm />
    <!-- Aquí se renderiza el componente -->
  </div>
</template>

<!-- <script setup>
import { onMounted } from 'vue';
onMounted(() => {
  document.body.classList.remove("overflow-hidden");
});
</script> -->

<script>
import PresupuestoForm from "../components/PresupuestoForm.vue";
import SideBar from "../components/NavBar.vue";

export default {
  name: "PresupuestoPage",
  components: {
    PresupuestoForm,
    SideBar, // Register the imported component here
  },
};
</script>

